export default __webpack_public_path__ + "static/media/Grips of the Amaranthine Drums.e5ace646.jpg";